<template>
    <div>
        <div
            @click.prevent="imageIndex = 0"
            class="halfImage"
            :style="{ 'background-image': 'url(' + imageURL(record.image_urls[0]) + ')' }"
        ></div>
        <div
            @click.prevent="imageIndex = 1"
            class="halfImage"
            :style="{ 'background-image': 'url(' + imageURL(record.image_urls[1]) + ')' }"
        ></div>
        <CoolLightBox :items="galleryImages" :index="imageIndex" @close="imageIndex = null">
        </CoolLightBox>
    </div>
</template>

<script>
import { imageURL } from "@/mixins/imageURL.js";
export default {
    props: ["record"],
    mixins: [imageURL],
    created() {
        this.galleryImages[0] = this.imageURL(this.record.image_urls[0]);
        this.galleryImages[1] = this.imageURL(this.record.image_urls[1]);
    },
    data() {
        return {
            imageIndex: null,
            galleryImages: [],
        };
    },
};
</script>

<style lang="scss" scoped>
.halfImage {
    width: calc(50% - 10px);
    margin-bottom: 20px;
    height: 200px;
    background-size: cover;
    border-radius: $radius;
    display: inline-block;
    &:first-of-type {
        margin-right: 20px;
    }
}
</style>
